module.exports = __webpack_public_path__ + "static/Aston-20186_bw2afs-39aba88cd350727b701f41d60bf36e6a.jpg";